import React from 'react';

import type { MethodType } from './types';

import { useI18n } from 'lib/i18n/context';
import ContentLoader from 'ui/shared/ContentLoader';
import DataFetchAlert from 'ui/shared/DataFetchAlert';

import { ADDRESS_CONTRACT_KEYS } from '../../i18n';

interface Props {
  isLoading?: boolean;
  isError?: boolean;
  isEmpty?: boolean;
  type: MethodType;
  children: React.JSX.Element;
}

const ContractMethodsContainer = ({ isLoading, isError, isEmpty, type, children }: Props) => {
  const { t } = useI18n();

  if (isLoading) {
    return <ContentLoader w="fit-content"/>;
  }

  if (isError) {
    return <DataFetchAlert/>;
  }

  if (isEmpty) {
    return (
      <span>
        { type === 'all' ?
          t(ADDRESS_CONTRACT_KEYS.notice.noPublicFunctions) :
          t(ADDRESS_CONTRACT_KEYS.notice.noPublicTypedFunctions, { type: t(ADDRESS_CONTRACT_KEYS.filters[type]) }) }
      </span>
    );
  }

  return children;
};

export default React.memo(ContractMethodsContainer);
